export function getNextStatement(state, selectedRow, selectedBegin, forward) {
  let target = state.pages[state.currentPage].bounds
  const baseComparator = (e1, e2) => {
    if (e1.rowIndex < e2.rowIndex) {
      return -1
    }
    if (e1.rowIndex > e2.rowIndex) {
      return +1
    }
    if (e1.beginIndex < e2.beginIndex) {
      return -1
    }
    if (e1.beginIndex > e2.beginIndex) {
      return +1
    }
    return 0
  }
  let comparator = baseComparator
  if (forward) {
    target = target.filter(
      (b) =>
        b.rowIndex > selectedRow ||
        (b.rowIndex === selectedRow && b.beginIndex > selectedBegin)
    )
  } else {
    target = target.filter(
      (b) =>
        b.rowIndex < selectedRow ||
        (b.rowIndex === selectedRow && b.beginIndex < selectedBegin)
    )
    comparator = (e1, e2) => {
      return baseComparator(e1, e2) * -1
    }
  }
  target.sort(comparator)
  return {
    rowIndex: target.length > 0 ? target[0].rowIndex : null,
    beginIndex: target.length > 0 ? target[0].beginIndex : null
  }
}

function getItemAnswers(answers) {
  return answers.map((answer) => answer.result.judge !== 'incorrect')
}

function getRowAnswers(answers) {
  return answers
    .map((answer) => getItemAnswers(answer.answer))
    .reduce((x, y) => x.concat(y), [])
}

function getAnswers(answers) {
  return answers
    .map((answer) => getRowAnswers(answer.answers))
    .reduce((x, y) => x.concat(y), [])
}

export function generateAnswer(minRate, state, selectedRow, selectedBegin) {
  if (!minRate) {
    return null
  }
  const rectPattern = /^!#(.+)$/
  const answers = getAnswers(state.answers)
  const skippableCount =
    answers.length - answers.filter((a) => a).length / minRate
  console.log('Skippable', skippableCount)
  if (skippableCount <= 0) {
    return null
  }
  const currentTime = Date.now()
  const bound = state.pages[state.currentPage].bounds.filter(
    (b) => b.rowIndex === selectedRow && b.beginIndex === selectedBegin
  )[0]
  const dummyAnswers = bound.row
    .filter((word) => !word.match(rectPattern) && word.split('|').length > 1)
    .map((word) => ({
      answer: word.split('|')[0],
      candidate: null,
      active: false,
      correct: word.split('|')[0],
      candidates: word.split('|'),
      answered: currentTime,
      result: {
        judge: 'skipped',
        semantic_score: 0,
        grammer_score: 0
      },
      started: currentTime
    }))
  if (dummyAnswers.length === 0) {
    return null
  }
  return {
    time: Date.now(),
    rowIndex: bound.rowIndex,
    beginIndex: bound.beginIndex,
    endIndex: bound.endIndex,
    answers: [
      {
        answer: dummyAnswers
      }
    ]
  }
}

class ClozeContent {
  constructor(data) {
    this.data = data
  }

  getRects(rects) {
    const rectPattern = /^(-?[0-9]+),(-?[0-9]+),(-?[0-9]+),(-?[0-9]+)(#.+)?/
    const rectMatch = rects.match(rectPattern)
    const baseRect = [[1, 2, 3, 4].map((i) => parseInt(rectMatch[i]))]
    if (!rectMatch[5]) {
      return baseRect
    }
    return baseRect.concat(this.getRects(rectMatch[5].substring(1)))
  }

  getPageId(row, rowIndex) {
    const imagePattern = /^!([^#]+)(#.+)?$/
    const imageMatch = row[0].match(imagePattern)
    if (imageMatch) {
      return {
        pageId: imageMatch[1],
        image: true,
        pageDefined: true,
        area:
          imageMatch[2] === undefined
            ? []
            : this.getRects(imageMatch[2].substring(1))
      }
    }
    const pagePattern = /^!([0-9]+)#$/
    const pageMatch = row[0].match(pagePattern)
    if (pageMatch) {
      return {
        pageId: pageMatch[1],
        image: false,
        pageDefined: true,
        area: null
      }
    }
    if (rowIndex > 0) {
      const prevRow = this.data.rows[rowIndex - 1]
      const { pageId, image, pageDefined } = this.getPageId(
        prevRow,
        rowIndex - 1
      )
      return {
        pageId,
        image,
        pageDefined,
        area: null
      }
    }
    return {
      pageId: `!R${rowIndex}`,
      image: false,
      pageDefined: false,
      area: null
    }
  }

  removeEmpties(bounds) {
    if (bounds.length === 1) {
      return bounds
    }
    return bounds.filter(
      (bound) =>
        bound.row.slice(bound.beginIndex, bound.endIndex).join('').trim()
          .length > 0
    )
  }

  getPages() {
    const rectPattern = /^!#(.+)$/
    const pages = []
    let bounds = null
    this.data.rows.forEach((row, rowIndex) => {
      const { pageId, image, pageDefined, area } = this.getPageId(row, rowIndex)
      if (pages.length === 0 || pages[pages.length - 1].pageId !== pageId) {
        bounds = []
        pages.push({ pageId, image, rowIndex, bounds })
      }
      let lastbound = {
        area,
        row,
        rowIndex,
        beginIndex: pageDefined ? 1 : 0,
        endIndex: row.length
      }
      bounds.push(lastbound)
      if (image) {
        row.slice(1).forEach((cell, i) => {
          const rectMatch = cell.match(rectPattern)
          if (!rectMatch) {
            return
          }
          lastbound.endIndex = i + 1
          const area = this.getRects(rectMatch[1])
          lastbound = {
            area,
            row,
            rowIndex,
            beginIndex: i + 2,
            endIndex: row.length
          }
          bounds.push(lastbound)
        })
      } else {
        row.forEach((cell, i) => {
          if (cell.trim() !== '.') {
            return
          }
          lastbound.endIndex = i + 1
          if (i + 1 === row.length) {
            return
          }
          lastbound = {
            area: null,
            row,
            rowIndex,
            beginIndex: i + 1,
            endIndex: row.length
          }
          bounds.push(lastbound)
        })
      }
    })
    pages.forEach((page) => {
      page.bounds = this.removeEmpties(page.bounds)
    })
    return pages
  }
}

export default ClozeContent
